import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { VerticalNavigation } from './';
import { Icon } from '../Icon';
import { CloseButton } from '../Buttons/CloseButton';
import { UnstyledButton } from '../Buttons';
const StyledHeader = styled.header `
  padding: 0px 10px 0px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 50px;
  border-bottom: 1px solid ${({ theme }) => theme.greyDarkMedium};
  width: 100%;
  background-color: ${({ theme }) => theme.primaryWhite};
  cursor: pointer;
  position: relative;

  span {
    font-family: ${({ theme }) => theme.fontFamilyHeading};
    font-size: 16px;
    font-weight: bold;
    line-height: 20px;
    color: ${({ theme }) => theme.secondaryBlue};
    cursor: pointer;
  }
`;
const NavigationCategoryContainer = styled.div `
  width: 100%;
  height: 46px;
  padding: 10px 0px 10px 35px;
  border-bottom: 1px solid ${({ theme }) => theme.greyLight};
  position: relative;
  background-color: ${({ theme }) => theme.primaryWhite};
  display: flex;
  align-items: center;
  background: ${({ theme }) => theme.greyLight};

  span {
    font-style: normal;
    font-size: 16px;
    line-height: 24px;
    font-family: ${({ theme }) => theme.fontFamilyBold};
  }
`;
const FlexContainer = styled(UnstyledButton) `
  border: none;
  background-color: ${({ theme }) => theme.primaryWhite};
  display: flex;
  align-items: center;
  padding: 0;
`;
const StyledSiteHeading = styled.span `
  font-style: normal;
  font-size: 16px;
  line-height: 20px;
  font-family: ${({ theme }) => theme.fontFamilyHeading};
  transform: translateX(-20px);
`;
const StyledSlidePanel = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  background-color: ${({ theme }) => theme.primaryWhite};
  transition: all 0.4s ease;

  // TODO: create resuable 'hook' from transformations
  transform: ${({ shouldSlideInView }) => (shouldSlideInView ? 'translateX(0%)' : 'translateX(110%)')};
`;
const StyledLeftArrowIcon = styled(Icon) `
  position: relative;
  font-size: 35px;
  transform: rotate(90deg);
  margin-right: 14px
  color: ${({ theme }) => theme.secondaryBlue};
`;
export const SlidePanel = ({ childMenuLabel, navigationItems, siteOwner, currentSite, clearChildMenuData, currentLanguage, allowContentToBeTabable, }) => {
    const [isTabable, setIsTabable] = useState(false);
    const [slideInView, setSlideInView] = useState(false);
    if (!childMenuLabel || !navigationItems)
        return null;
    useEffect(() => {
        if (allowContentToBeTabable) {
            setIsTabable(true);
        }
        else {
            setIsTabable(false);
        }
    }, [allowContentToBeTabable]);
    useEffect(() => {
        setTimeout(() => {
            setSlideInView(true);
        }, 300);
    }, []);
    const removeChildNav = () => {
        setSlideInView(false);
        setTimeout(() => {
            clearChildMenuData();
        }, 550);
    };
    return (React.createElement(StyledSlidePanel, { shouldSlideInView: slideInView },
        React.createElement(StyledHeader, null,
            React.createElement(FlexContainer, { onClick: () => removeChildNav() },
                React.createElement(StyledLeftArrowIcon, null, "arrow_drop_down"),
                React.createElement(StyledSiteHeading, { onClick: () => removeChildNav() }, currentSite.charAt(0).toUpperCase() + currentSite.slice(1))),
            React.createElement(CloseButton, { onClick: () => removeChildNav() })),
        React.createElement(NavigationCategoryContainer, null,
            React.createElement("span", null, childMenuLabel)),
        React.createElement(VerticalNavigation, { navigationItems: navigationItems, siteOwner: siteOwner, currentSite: currentSite, currentLanguage: currentLanguage, allowContentToBeTabable: isTabable, navigationType: "secondary-navigation" })));
};
